import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=73996290&scoped=true"
import script from "./CustomerInfo.vue?vue&type=script&lang=ts"
export * from "./CustomerInfo.vue?vue&type=script&lang=ts"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&id=73996290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73996290",
  null
  
)

export default component.exports